import { isString } from 'lodash'
import { LAWYER } from './accountTypes'
import { composeQuery, getRootCollection } from './queries'

export const getUserId = (user) => (isString(user) ? user : user.uid)
export const listUsers = () => getRootCollection('users')

const whereAccountType = (accountTypeId) => (query) =>
  query.where('accountType', '==', accountTypeId)

export const listLawyers = () =>
  composeQuery(listUsers, whereAccountType(LAWYER.id))
